module.exports = __webpack_public_path__ + "img/background014.7d5db497.jpg";